import { useForm } from 'antd/es/form/Form';
import { get } from 'lodash-es';
import { useEffect, useState } from 'react';

import { membersActions } from '@store/members/members.slice';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useAddMemberMutation } from '@hook/memeber/memeber.hooks';
import { MemberInputInterface } from '@interface/member/member.interface';

export const useAccountMembersInvite = () => {
  const [form] = useForm();
  const { current } = useCurrentApplication();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { action: addMember, state } = useMutation(useAddMemberMutation(), membersActions, membersActions.setData);
  const onOpenModal = () => setIsModalOpen(true);
  const onCloseModal = () => setIsModalOpen(false);

  useEffect(() => void (state.isSuccess && setIsModalOpen(false)), [state.isSuccess]);

  useEffect(() => void (!isModalOpen && form.resetFields()), [isModalOpen]);

  const onFinish = (data: MemberInputInterface) =>
    addMember({
      account: get(current, ['account', 'id']),
      data,
    });

  return {
    form,
    isModalOpen,
    isLoading: state.isLoading,
    onOpenModal,
    onCloseModal,
    onFinish,
  };
};
